import { render, staticRenderFns } from "./MainBarMenuV2.vue?vue&type=template&id=29b3fbb2&scoped=true"
import script from "./MainBarMenuV2.vue?vue&type=script&lang=js"
export * from "./MainBarMenuV2.vue?vue&type=script&lang=js"
import style0 from "./MainBarMenuV2.vue?vue&type=style&index=0&id=29b3fbb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3fbb2",
  null
  
)

export default component.exports